// Flow's documentation: Settings › Help in the sandbox-first experience; the sidebar footer's "?" only where there is
// no Settings page (pages/UserSettings.jsx, components/FlowSidebar.jsx).
export const FLOW_DOCS_URL = 'https://docs.mia-platform.eu/docs/products/flow/overview';
